import React, { useEffect, useState } from "react";
import Select from "react-select";
import Toast from '../../../../Components/Toast/Toast'
import { useAuthState } from "../../../../Helper/Context/context";
import { useDispatch, useSelector } from "react-redux";
import { ProjectNameDDL } from "../../../../Components/CommonDDL/ProjectNameDDL";
import { StateNameDDL } from "../../../../Components/CommonDDL/StateNameDDL";
import { RegionalOfficeNameDDL } from "../../../../Components/CommonDDL/RegionalOfficeNameDDL";
import { FieldStationOfficerDDL } from "../../../../Components/CommonDDL/FieldStationOfficerDDL";
import { DistrictDDL } from "../../../../Components/CommonDDL/DistrictDDL";
import { DefineProjectwisestateareaPatchAPI } from "../../../../Helper/Redux/MasterSlice/DefineProjectWiseStateAreaSlice";
import { UnitNameDDL } from "../../../../Components/CommonDDL/UnitNameDDL";
import DeletePopUP from "../../../../Components/CommonPopUp/DeletePopUp";
import { AstricSign } from "../../../../Helper/AstricSign";
import { RegExDecimalValue, RegExNumbersOnly } from "../../../../Helper/regEx/RegExOnlyText";

export default function UpdateStateWiseProjectAreaPopUp(props) {

  const { handleShowUpdateModal, handleIsPost, ShowUpdateModal, From, IsPost, IsSearch, IsClear } = props
  const { flag, data } = ShowUpdateModal

  // console.log("flag",flag)

  const userDetails = useAuthState();
  const { UserID, token } = userDetails
  const dispatch = useDispatch()

  const [ProjectArea, setProjectArea] = useState(flag == 'Update' ? data?.projectArea : "")
  const [ShowDeletePopup, setShowDeletePopup] = useState(false)
  const [IsPostPopUp, setIsPostPopUp] = useState(false)
  const [ShowDeletePopupData, setShowDeletePopupData] = useState({
    data: ''
  })

  const [ProjectNameID, setProjectNameID] = useState({
    DDL: [],
    ID: flag == 'Update' ? data?.m_ProjectID : 0,
    Label: flag == 'Update' ? data?.projectName : "Select...",
  })
  const [StateID, setStateID] = useState({
    DDL: [],
    ID: flag == 'Update' ? data?.m_StateNameID : 0,
    Label: flag == 'Update' ? data?.stateName : "Select...",
  })
  const [RegionalOfficeID, setRegionalOfficeID] = useState({
    DDL: [],
    ID: flag == 'Update' ? data?.m_RegionalOfficeID : 0,
    Label: flag == 'Update' ? data?.regionalOffice : "Select...",
  })

  const [FieldStationOfficerID, setFieldStationOfficerID] = useState({
    DDL: [],
    ID: flag == 'Update' ? data?.m_FieldStationOfficerID : 0,
    Label: flag == 'Update' ? data?.fieldStation : "Select...",
  })

  const [DistrictID, setDistrictID] = useState({
    DDL: [],
    ID: flag == 'Update' ? data?.m_DistrictNameID : 0,
    Label: flag == 'Update' ? data?.m_DistrictName : "Select...",
  })

  const [RawData, setRawData] = useState([])
  const [UnitID, setUnitID] = useState(data && data?.m_UnitID)
  const [UnitName, setUnitName] = useState(data && data?.unitName)
  const [PopUpGridData, setPopUpGridData] = useState([])
  const [IsTrue, setISTrue] = useState(false)

  const handleSubmit = () => {
    const data = {
      M_ProjectAreaID: flag == 'Update' ? ShowUpdateModal.data.m_ProjectAreaID : 0,
      M_ProjectID: ProjectNameID.ID,
      M_StateID: StateID.ID,
      M_RegionalOfficeID: RegionalOfficeID.ID,
      M_FieldStationOfficerID: FieldStationOfficerID.ID,
      M_DistrictID: DistrictID.ID,
      ProjectArea: ProjectArea,
      M_UnitID: UnitID ? UnitID : '0',
      M_TableUserMasterID: UserID,
      Flag: flag,
      token: token,
      handleIsPost
    }
    dispatch(DefineProjectwisestateareaPatchAPI({ data }))
  }

  const { isPostLoading } = useSelector(state => state.DefineProjectwisestateareaPatchData)

  const handleClear = () => {
    setProjectArea('')

    setStateID({
      ...StateID,
      ID: 0,
      Label: "Select...",
    })
    setRegionalOfficeID({
      ...RegionalOfficeID,
      ID: 0,
      Label: "Select...",
    })
    setFieldStationOfficerID({
      ...FieldStationOfficerID,
      ID: 0,
      Label: "Select...",
    })

  }

  

  const [IsValidDecimalNo, setIsValidDecimalNo] = useState(false)

  const handleCheckDecimalNumberOnly = (e) => {
    setProjectArea(e.target.value)
      const IsValidDecimalNo = RegExDecimalValue(e.target.value)
      setIsValidDecimalNo(IsValidDecimalNo)
      return IsValidDecimalNo
  }

  return (
    <>
      <div
        className="modal fade show"
        style={{ display: "block", backgroundColor: "#00000055" }}
      >
        <div className="modal-dialog add_popup modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header pl-4">
              <h5 className="modal-title" id="exampleModalLongTitle">
                Define Project wise state area
              </h5>
              <button
                onClick={() => handleShowUpdateModal(false, '')}
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body mx-4">
              <div className="row">
                <div className="col-lg-4">
                  <ProjectNameDDL
                    ProjectNameID={ProjectNameID}
                    setProjectNameID={setProjectNameID}
                    // DisableFlag="Add"
                    apiFlag='Master'
                    Flag={flag}
                    data={data}
                    IsPost=''
                    AstricSignFlag = "AstricSign"
                  />
                </div>
                <div className=" col-lg-4">
                  <StateNameDDL
                    StateID={StateID}
                    setStateID={setStateID}
                    apiFlag='Master'
                    Flag={flag}
                    data={data}
                    IsPost=''
                    AstricSignFlag = "AstricSign"
                  />
                </div>
                <div className=" col-lg-4">
                  <RegionalOfficeNameDDL
                    RegionalOfficeID={RegionalOfficeID}
                    setRegionalOfficeID={setRegionalOfficeID}
                    apiFlag='Master'
                    Flag={flag}
                    data={data}
                    IsPost=''
                    StateID={StateID}
                    AstricSignFlag = "AstricSign"
                  />
                </div>
                <div className="col-xl-4 col-lg-4">
                  <FieldStationOfficerDDL
                    FieldStationOfficerID={FieldStationOfficerID}
                    setFieldStationOfficerID={setFieldStationOfficerID}
                    apiFlag='Master'
                    Flag={flag}
                    data={data}
                    IsPost=''
                    RegionalOfficeID={RegionalOfficeID}
                    AstricSignFlag = "AstricSign"
                  />
                </div>
                <div className=" col-lg-4">
                  <DistrictDDL
                    DistrictID={DistrictID}
                    setDistrictID={setDistrictID}
                    StateID={StateID}
                    apiFlag='Master'
                    Flag={flag}
                    data={data}
                    IsPost=''
                    AstricSignFlag = "AstricSign"
                  
                  />
                </div>

                <div className="col-xl-4 col-lg-4">
                  {/* <div className="col-12 col-md-5"> */}
                  <div className="col-12">
                    <label for="exampleInputEmail1" className="form-label"> Project Area (Acres) <AstricSign/></label>
                  </div>
                  {/* </div> */}

                  <div className="col-12">
                    <div className="col-12">
                      <div className="input-group ">
                        <input
                          type="text"
                          className="form-control"
                          name="ProjectArea"
                          value={ProjectArea}

                          onChange={(e) => handleCheckDecimalNumberOnly(e)}
                        />
                        <span className="input-group-text">
                          <UnitNameDDL
                            UnitID={UnitID}
                            setUnitID={setUnitID}
                            UnitName={UnitName}
                            setUnitName={setUnitName}
                            apiFlag='Master'
                            Flag={flag}
                            data={data}
                            IsPost=''
                            RegionalOfficeID={RegionalOfficeID}
                          />


                        </span>
                        {
                          IsValidDecimalNo && <text style={{ color: 'red' }}>Please enter Numbers only</text>
                        }
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-12">
                  <div className="form-group float-end mt-lg-3 mt-4">

                    <button type="button" className="btn btn-outline-dark border-2 mx-2"
                      // disabled={ProjectName == ""}
                      onClick={handleSubmit}> Update</button>

                    <button type="button" className="btn btn-danger border-2"
                       onClick={() => handleShowUpdateModal(false, '')}
                      >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>        
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
